import React, { FC, ChangeEvent } from "react";

type PropsType = {
  name: string;
  value?: string | number;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  readOnly?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const CheckBox: FC<PropsType> = ({
  name,
  value,
  checked = false,
  readOnly = false,
  required = false,
  disabled = false,
  className = "",
  onChange,
}: PropsType) => {
  return (
    <input
      type="checkbox"
      name={name}
      id={name}
      value={value}
      readOnly={readOnly}
      checked={checked}
      required={required}
      disabled={disabled}
      className={`w-5 h-5 accent-icon-reply shrink-0 ${className}`}
      onChange={onChange}
    />
  );
};
